const Class = require('../../base/Class');
const GeometryUtil = require('../../utils/GeometryUtil');
const CoordUtil = require('../../utils/CoordUtil');
const g2 = require('../../g2');
/**
 * @constructor
 * @classdesc 坐标构建器
 * @alias G.utils.GeometryBuilder
 * @augments G.base.Class
 * @param {Object} options 构造参数
 * @param {Integer} options.sourceSr 数据坐标系
 * @param {Integer} options.targetSr 目标坐标系
 * @param {Array} options.geometryField 坐标属性名，默认为['geom']，使用经纬度属性时，可指定x、y两个字段名，如：['x','y']
 * @param {String} options.geometryType 空间类型 point/polyline/polygon  分别对应点线面
 * @returns {Object} 实例化对象
 */
const GeometryBuilder = Class.extend({
    options: {
        sourceSr: 4326,
        targetSr: 4326,
        geometryField: ['geom'],
        geometryType: 'point'
    },
    initialize(options) {
        Class.setOptions(this, options);
        this.projService = new g2.sfs.CoordinateTransform({});
    },
    /**
     * 销毁
     * @method
     * @memberOf G.utils.GeometryBuilder.prototype
     */
    destroy() {
    },
    
    
    /**
     * 获取坐标类型
     * @method
     * @memberOf G.utils.GeometryBuilder.prototype
     */
    getGeometryType() {
        return this.options.geometryType;
    },
    
    /**
     * 构造坐标
     * @method
     * @memberOf G.utils.GeometryBuilder.prototype
     * @param data {Object}
     * @returns  {g2.sfs.Geometry}
     */
    build(data) {
        let geometry = this._build(data);
        let geometryCheck = this.check(geometry);
        if (!geometryCheck){
            geometry = null;
            throw "无效坐标";
        }
        return geometry;
    },
    
    /**
     * 检查坐标是否有效
     * @param geometry
     */
    check(geometry) {
        let check = this._check(geometry);
        return check;
    },
    /**
     * 点数据
     * @param data
     * @private
     */
    _build(data) {
        let srcSpatialReference = this.options.sourceSr,
            destSpatialReference = this.options.targetSr;
        var geometryField = this.options.geometryField, geometry = null;
        try {
            if (geometryField.length == 1) {
                let geometryObj = data[geometryField[0]];
                try {
                    if (typeof geometryObj == 'string') {
                        // geometryObj = this.wktReader.read(geometryObj).toString();
                        geometry = g2.sfs.GeometryFactory.createGeometryFromWkt(geometryObj, srcSpatialReference);
                    } else {
                        geometry = g2.sfs.GeometryFactory.createGeometryFromGeoJson(geometryObj, srcSpatialReference);
                    }
                } catch (e) {
                }
            }
            else if (geometryField.length == 2) {
                let x, y;
                x = this._getXyVal(data, geometryField[0]);
                y = this._getXyVal(data, geometryField[1]);
                geometry = new g2.sfs.Point({x: x, y: y, spatialReference: srcSpatialReference});
            }
        } catch (e) {
            throw e
        }
        //需要转换坐标系
        if (srcSpatialReference && destSpatialReference && srcSpatialReference != destSpatialReference) {
            geometry = this.projService.transform(geometry, destSpatialReference);
        }
        return geometry;
    },
    _check: function (geometry) {
        let srcSpatialReference = this.options.sourceSr;
        var check = true;
        //点的坐标验证
        if (geometry instanceof g2.sfs.Point) {
            var coords = GeometryUtil.validateCoordinate(geometry.x, geometry.y, srcSpatialReference);
            if (!coords) {
                check = false;
                throw new Error('无效坐标！');
            } else {
                var verifyFlag = CoordUtil.verify(coords, srcSpatialReference);
                if (!verifyFlag) {
                    check = false;
                    throw new Error('无效坐标！');
                }
            }
            
        }
        return check;
        
    },
    _getXyVal: function (data, field) {
        var val;
        try {
            if (field.indexOf('.') < 0) {
                val = data[field];
            } else {
                val = parseFloat(eval('data.' + field));
            }
        } catch (e) {}
        return val;
    }
});

module.exports = GeometryBuilder;